import React from 'react'
import { Component } from 'reflux'
import { toast } from 'react-toastify'
import { ExpectedDeliveryStatusActions, ExpectedDeliveryStatusStore, STATUS } from 'Stores/expectedDeliveryStatusStore'
import ExpectedDeliveryStatusForm from 'Modules/ExpectedDeliveryStatus/expectedDeliveryStatusForm'

export default class ExpectedDeliveryStatusCreate extends Component {
  constructor(props) {
    super(props)
    this.stores = [ExpectedDeliveryStatusStore]
    this.storeKeys = ['status']
  }
  componentDidMount() {
    ExpectedDeliveryStatusActions.createEmptyExpectedDeliveryStatus()
  }
  componentDidUpdate() {
    if (this.state.status === STATUS.UPDATE_SUCCESS) {
      toast.success('ExpectedDeliveryStatus Created', {
        autoClose: 3000,
        onClose: () => {
          ExpectedDeliveryStatusActions.clearFormToast()
        }
      })
      ExpectedDeliveryStatusActions.clearFormToast(STATUS.REDIRECT)
    }
    if (this.state.status === STATUS.UPDATE_ERROR) {
      toast.error('ExpectedDeliveryStatus Create Failed', {
        autoClose: 3000,
        onClose: () => {
          ExpectedDeliveryStatusActions.clearFormToast()
        }
      })
      ExpectedDeliveryStatusActions.clearFormToast(STATUS.REDIRECT)
    }
  }

  render() {
    return (
      <React.Fragment>
        <ExpectedDeliveryStatusForm />
      </React.Fragment>
    )
  }
}
